export default __webpack_public_path__ + "b94438e2602ba1300fe43ee0e1c9b8b1.png";